'use client';

import { type FC } from 'react';

import styles from 'components/FAQ/faq.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { FAQProps } from 'components/FAQ/config';

interface FaqProps {
  heading?: string;
  faqs?: { title?: string; link?: string }[];
  className?: string;
}

const FAQColumn: FC<FaqProps> = ({ heading, faqs, className }) => (
  <div className={className}>
    {heading && <div className={styles.title}>{heading}</div>}
    {isNonEmptyArray(faqs) &&
      faqs.map((faq, index) => (
        <li key={index} className={styles.faq}>
          <a href={faq.link || ''} className={styles.addArrow}>
            {faq.title}
          </a>
        </li>
      ))}
  </div>
);

const FAQ: FC<FAQProps> = ({ heading, leftFaq, rightFaq }) => (
  <div className={styles.wrapper}>
    {heading && (
      <div className={styles.background}>
        <h1 className={`${styles.container} ${styles.heading}`}>{heading}</h1>
      </div>
    )}
    <div className={`${styles.twoColumn} ${styles.container} ${rightFaq ? styles.fullPadding : styles.halfPadding}`}>
      {leftFaq && <FAQColumn {...leftFaq} className={styles.column} />}
      {rightFaq && <FAQColumn {...rightFaq} className={styles.column} />}
    </div>
  </div>
);

export default FAQ;
